<template>
  <!-- 新闻中心页面 -->
  <div>
    <!-- PC端 -->
    <div class="news_box" v-if="webFlag">
      <!-- 头部 -->
      <head-nav :selectedId="3"></head-nav>
      <img src="../assets/images/banner07.png" alt="" style="width: 100%" />
      <el-container>
        <el-aside width="100%">
          <title-com :name="'新闻中心'" :letter="'NEWS CENTER'"></title-com>
          <el-row>
            <el-col :span="8">
              <el-menu default-active="/solution" class="el-menu-demo">
                <el-menu-item
                  v-for="(item, i) in newsList"
                  :key="i"
                  @click="eventHandle(i)"
                  :class="{ actived: is_active == i }"
                >
                  <ul>
                    <li>
                      <span class="point"></span>
                      <span>{{ item.text }}</span>
                      <img
                        :src="is_active == i ? item.url : item.path"
                        alt=""
                        class="icon"
                      />
                    </li>
                  </ul>
                </el-menu-item>
              </el-menu>
            </el-col>
            <el-col :span="16">
              <news v-if="is_active == 0" @myEvent="getFlag"></news>
              <announcement v-if="is_active == 1" @myEvent="getFlag"></announcement>
              <information v-if="is_active == 2" @myEvent="getFlag"></information>
              <details-com
                v-if="flag"
                @func="changeFlag"
                :id="id"
                :arr="arr"
              ></details-com>
            </el-col>
          </el-row>
        </el-aside>
      </el-container>
      <!-- 尾部 -->
      <footer-com />
    </div>
    <!-- 移动端 -->
    <div class="news_box" v-if="mobilPhoneFlag">
      <!-- 头部 -->
      <mobileHead></mobileHead>
      <img
        src="@/assets/images/banner07.png"
        alt=""
        class="banner"
        style="width: 100%; margin: 44px 0"
      />
      <el-container>
        <el-aside width="90%" style="margin: 0 auto">
          <title-com :name="'新闻中心'" :letter="'NEWS CENTER'"></title-com>
          <div class="part">
            <div
              class="part-item"
              v-for="(item, i) in newsList"
              :key="i"
              @click="eventHandle(i)"
              :class="{ actived: is_active == i }"
            >
            <img :src="is_active==i?item.path:item.gray" alt="" />
              <p>{{item.text}}</p>
            </div>
          </div>
          <div>
            <news v-if="is_active == 0" @myEvent="getFlag"></news>
            <announcement v-if="is_active == 1" @myEvent="getFlag"></announcement>
            <information v-if="is_active == 2" @myEvent="getFlag"></information>
            <details-com
              v-if="flag"
              @func="changeFlag"
              :id="id"
              :arr="arr"
            ></details-com>
          </div>
        </el-aside>
      </el-container>
      <!-- 尾部 -->
      <mobile-footer></mobile-footer>
    </div>
  </div>
</template>

<script>
import headNav from "@/components/header.vue";
import footerCom from "@/components/footer.vue";
import titleCom from "@/components/title.vue";
import news from "@/components/newsCenter/news.vue";
import announcement from "@/components/newsCenter/announcement.vue";
import information from "@/components/newsCenter/information.vue";
import detailsCom from "@/components/newsCenter/details.vue";
// 移动端组件
import mobileHead from "@/components/publicCom/mobileHead.vue";
import mobileFooter from "@/components/publicCom/mobileFooter.vue";
export default {
  components: {
    headNav,
    footerCom,
    titleCom,
    news,
    announcement,
    information,
    detailsCom,
    mobileHead,
    mobileFooter,
  },

  data() {
    return {
      newsList: [
        {
          id: 0,
          name: "introduce",
          text: "公司新闻",
          url: require("../assets/images/icon_about_news01.png"),
          path: require("../assets/images/icon_about_news02.png"),
          gray: require("../assets/images/icon_about_news03.png"),
        },
        {
          id: 1,
          name: "culture",
          text: "行业资讯",
          url: require("../assets/images/icon_about_information01.png"),
          path: require("../assets/images/icon_about_information02.png"),
          gray: require("../assets/images/icon_about_information03.png"),
        },
        {
          id: 2,
          name: "honor",
          text: "通知公告",
          url: require("../assets/images/icon_about_notice01.png"),
          path: require("../assets/images/icon_about_notice02.png"),
          gray: require("../assets/images/icon_about_notice03.png"),
        },
      ],
      is_active: 0,
      flag: false,
      type: "",
      webFlag: true,
      mobilPhoneFlag: false,
      id: 0,
      arr: [],
      newsDetails: {},
    };
  },
  mounted() {
    this.getScreenWidth();
    this.getDetails();
  },
  methods: {
    // 获取设备宽度
    getScreenWidth() {
      console.log(document.body.offsetWidth, window.screen.availWidth);
      if (window.screen.availWidth <= 1366) {
        this.webFlag = false;
        this.mobilPhoneFlag = true;
        console.log(window.screen.availWidth);
      }
    },
    eventHandle(index) {
      this.is_active = index;
      this.flag = false;
      this.type = index + 1;
      console.log(this.type);
    },
    getFlag(val, id, arr) {
      this.is_active = -1;
      this.flag = val;
      this.id = Number(id);
      this.arr = arr;
    },
    changeFlag(val) {
      console.log(val);
      this.is_active = 0;
      this.flag = val;
    },
    // 获取新闻内容
    getNews() {
      this.$axios.get().then((res) => {
        console.log(res);
      });
    },
    backEvent() {
      // this.$emit("func", this.flag);
      this.flag = false;
    },
    // 详情
    getDetails() {
      console.log(this.id);
      this.$axios
        .get("/content/content/getContentInfo/" + this.id)
        .then((res) => {
          console.log(res);
          this.newsDetails = res.data;
        });
    },
    // 上一个
    lastEvent() {
      for (let i in this.arr) {
        if (this.nowId == this.arr[i].id) {
          if (i == 0) {
            this.$message({
              type: "warning ",
              message: "已经是第一条内容了",
            });
          } else {
            let id = this.arr[i - 1].id;
            console.log(id);
            this.$axios
              .get("/content/sample/getSampleInfo/" + id)
              .then((res) => {
                console.log(res);
                this.newsDetails = res.data;
                this.nowId = res.data.id;
              });
          }
        }
      }
    },
    // 下一个
    nextEvent() {
      for (let i in this.arr) {
        if (this.nowId == this.arr[i].id) {
          if (i == this.arr.length - 1) {
            this.$message({
              type: "warning ",
              message: "已经是最后一条内容了",
            });
          } else {
            let index = Number(i) + 1;
            let id = this.arr[index].id;
            this.$axios
              .get("/content/sample/getSampleInfo/" + id)
              .then((res) => {
                this.newsDetails = res.data;
                this.nowId = res.data.id;
              });
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1367px) {
  .el-container {
    margin: 40px 100px;
    .el-menu {
      width: 80%;
      margin: 0 auto;
      .el-menu-item {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        height: 80px;
        line-height: 80px;
        color: #454545;
        padding: 0;
        ul > li {
          list-style-type: square;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0;
        }
      }
      .actived {
        width: 100%;
        color: #ffffff;
        background: #3660d9;
      }
      .icon {
        width: 38px;
        height: 38px;
      }
      .point {
        width: 5px;
        height: 5px;
        background: #e0e0e0;
      }
    }
  }
}
@media screen and (max-width: 1366px) {
  .news_box {
    background: rgb(237, 237, 237);
  }
  .part {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 20px 0;
    .part-item {
      padding: 10px 0;
      background: #fff;
      width: 30%;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #454545;
      opacity: 0.8;
      img {
        width: 30px;
        height: 30px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/newsCenter.vue